function readDisableRecentModulesEnv() {
  try {
    return process.env.REACT_APP_DISABLE_RECENT_MODULES;
  } catch {
    return undefined;
  }
}

export function isRecentModulesDisabled() {
  // 1) Build-time env flag
  const env = String(readDisableRecentModulesEnv() || '').trim().toLowerCase();
  if (env === '1' || env === 'true' || env === 'yes') return true;

  // 2) Runtime flags
  if (typeof window === 'undefined') return false;

  try {
    const qs = new URLSearchParams(window.location.search || '');
    if (qs.get('disableRecentModules') === '1') return true;
  } catch {
    // ignore
  }

  try {
    return String(localStorage.getItem('kanplan-disable-recent-modules') || '') === '1';
  } catch {
    return false;
  }
}
